/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import configureStore from "./configureStore";

const storeObj = configureStore();

export const persistor = storeObj.persistor;
export const store = storeObj.store;
